import React from 'react';
import * as _ from 'lodash';

import { Information } from './common';
import { messageUtility } from '../../utilities/messageUtility';

const ExportExcelDialog = ({
  dialog: {
    masterName,
    downloadItems,
    handleDownload,
    onClose,
    maxRecord = 1000,
  },
}) => {
  const renderMessage = () => {
    return (
      <React.Fragment>
        <div>
          <p className='description'>
            {messageUtility.getMessage('I-001-441', masterName, maxRecord)}
          </p>
          <p className='description'>
            {messageUtility.getMessage('I-001-442')}
          </p>
        </div>

        <ul className='download-group'>
          {_.map(downloadItems, item => (
            <DownloadLink
              key={item.id}
              handleDownload={handleDownload}
              id={item.id}
              url={item.src}
            />
          ))}
        </ul>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <Information
        visible={true}
        rootClassName='ExportExcelDialog dialog--wide'
        title={messageUtility.getMessage('I-001-440', masterName)}
        message={renderMessage()}
        buttonText={messageUtility.getMessage('I-000-017')}
        multiple={true}
        onClose={onClose}
      />
    </React.Fragment>
  );
};

const DownloadLink = ({ id, url, handleDownload }) => {
  const downloadFile = () => {
    if (_.isFunction(handleDownload)) {
      handleDownload(id, url);
    }
  };
  return (
    <li key={id} className='download-group__item'>
      <span className='download-group__link-marker'>●</span>
      <div className='download-group__link' onClick={downloadFile}>
        {`${id}番目のファイルを出力する`}
      </div>
    </li>
  );
};

export default ExportExcelDialog;



// WEBPACK FOOTER //
// ./src/components/modals/ExportExcelDialog.jsx